/**
 * @file: 右键菜单初始化
 * @author: xiaolong.huang@dmall.com
 */

import ShortCutKey from '../shortcutkey/index';
import { createContextmenu } from './createContextmenu';
import { show, hide } from './toggleMenu';
import { dispatchClickAction } from './dispatchClickAction';

function init(): void {
    // 创建右键菜单UI
    createContextmenu();

    // 右键菜单点击事件分发
    dispatchClickAction();
}

export {
    init
};
